/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import { captureException, addBreadcrumb, captureEvent } from '@sentry/core';
import { Severity } from '@sentry/browser';
import qs from 'qs';

// https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
export function retryImport<T>(
  importFn: () => Promise<{ default: React.ComponentType<T> }>
): Promise<{ default: React.ComponentType<T> }> {
  return new Promise((resolve, reject) => {
    importFn()
      .then(resolve)
      .catch((error) => {
        // try to clear cache and reload once
        const queryParams = qs.parse(window.location.search.substring(1));
        if (!queryParams.reloaded) {
          captureEvent({
            message: `Chunk load failed - attempting to clear cache and hard refresh`,
            level: Severity.Warning
          });

          // Clear cache and reload
          if (window.caches) {
            window.caches.keys().then((names) => {
              for (let name of names) window.caches.delete(name);
            });
          }
          window.location.href = `${window.location.href}?reloaded=true`;
          return;
        }

        // if all attempts fail, reject
        addBreadcrumb({
          message: `Chunk load failed - hard refresh failed`,
          level: Severity.Warning
        });
        captureException(error);
        reject(error);
      });
  });
}
